import React, {ReactElement, ReactNode} from 'react';
import {Alignment} from '../../../types';
import LayoutSection, {LayoutBackground} from '../Layout/LayoutSection/LayoutSection';
import DynamicLink from '../../DynamicLink/DynamicLink';
import Headers, {HeaderType} from '../Text/Headers/Headers';
import Paragraph, {FontSize} from '../Text/Paragraph/Paragraph';

import './UpdatesBlock.scss';

interface UpdatesBlockProps {
  ctaText: string;
  ctaUrl: string;
  description: ReactNode;
  image: string;
  imageAlignment: Alignment.LEFT | Alignment.RIGHT;
  subText: ReactNode;
  subTitle: ReactNode;
  title: ReactNode;
}

function UpdatesBlock({
  ctaText,
  ctaUrl,
  description,
  image,
  imageAlignment,
  subText,
  subTitle,
  title,
}: UpdatesBlockProps): ReactElement {
  const imageDiv = (
    <div
      className="updatesBlock__image"
      style={{
        backgroundImage: `url(${image})`,
      }}
    />
  );

  return (
    <LayoutSection innerClassName="updatesBlock" type={LayoutBackground.WHITE} slim>
      {imageAlignment === Alignment.LEFT && imageDiv}
      <div className="updatesBlock__wrapper">
        <Headers headerType={HeaderType.H2} alignment={Alignment.LEFT}>
          {title}
        </Headers>
        <Headers headerType={HeaderType.H4} alignment={Alignment.LEFT}>
          {subTitle}
        </Headers>
        <Paragraph className="updatesBlock__description">{description}</Paragraph>
        <DynamicLink className="button button--callToAction updatesBlock__cta" href={ctaUrl}>
          {ctaText}
        </DynamicLink>
        <Paragraph fontSize={FontSize.MEDIUM}>{subText}</Paragraph>
      </div>
      {imageAlignment === Alignment.RIGHT && imageDiv}
    </LayoutSection>
  );
}

export default UpdatesBlock;
